/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-restricted-globals */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useRef } from 'react';

import classNames from 'classnames';
import { useNavigate, NavLink } from 'react-router-dom';
import Inputmask from 'inputmask';

import Tooltip from '../../Tooltip';

export default function TextInput({
  label,
  type,
  name,
  value,
  onChange,
  onBlur,
  error,
  touched,
  link,
  tabindex,
  isVisible,
  mask,
  readOnly,
  postfix,
  disabled,
  onFocus,
  maxLength,
  tooltip,
  reference,
}) {
  const ref = useRef();
  const inputRef = reference || ref;

  const navigate = useNavigate();

  // Focus on input if tabindex = 1
  useEffect(() => {
    if (tabindex === 1) {
      inputRef.current.focus();
    }
  }, [tabindex, isVisible, inputRef]);

  // Apply mask if mask prop is passed
  useEffect(() => {
    if (mask) {
      const input = inputRef.current;
      Inputmask(mask).mask(input);
    }
  }, [inputRef, mask]);

  // If type is number, prevent negative numbers
  useEffect(() => {
    if (type === 'number' && value < 0) {
      onChange({ target: { name, value: 0 } });
    }
  }, [value, type, onChange, name]);

  const readOnlyWithLink = !!(link && readOnly);

  return (
    <div>
      <label
        className="flex text-sm font-medium mb-1 items-center gap-2"
        htmlFor={name}
        onClick={(event) => {
          // Prevent focus on input if there is a link, so click on label does redirect to link
          if (readOnlyWithLink) {
            event.preventDefault();
          }
        }}
      >
        {label}{' '}
        {tooltip && (
          <Tooltip size="md" position="bottom">
            {tooltip}
          </Tooltip>
        )}
      </label>
      <div
        className="flex gap-2 items-end"
        onClick={() => {
          if (readOnlyWithLink) {
            navigate(link());
          }
        }}
      >
        <input
          type={!readOnly ? type || 'text' : 'text'}
          onFocus={onFocus}
          readOnly={readOnly || disabled}
          onKeyDown={(event) => {
            if (
              type === 'number' &&
              isNaN(event.key) &&
              event.key !== 'Backspace' &&
              event.key !== 'Tab' &&
              event.key !== 'Delete' &&
              event.key !== '-'
            ) {
              event.preventDefault();
            }
          }}
          ref={inputRef}
          id={name}
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          className={classNames('form-input w-full', {
            'border-0 shadow-none': readOnly,
            'cursor-pointer text-indigo-500 underline': readOnlyWithLink,
          })}
          min={type === 'number' ? 0 : undefined}
          tabIndex={readOnly ? -1 : tabindex}
          maxLength={maxLength}
        />
        {postfix && <span className="text-sm pb-2">{postfix}</span>}
      </div>
      {link && (
        <NavLink
          className="inline-block w-full text-sm underline hover:no-underline text-right"
          to={link.url}
          tabIndex={-1}
        >
          {link.title}
        </NavLink>
      )}
      {error && touched && !readOnly && (
        <div className="text-red-500 text-sm mt-1">{error}</div>
      )}
    </div>
  );
}
